import React from "react";
import HeaderNav from "./HeaderNav";
import HeaderMobileNav from "./HeaderMobileNav";
import { Link } from "react-router";
import _ from "lodash";

/**
 * TODO -- This class needs a lot of updates:
 *
 * It uses deprecated properties (e.g. event.keyCode)
 * and is full of direct DOM manipulation, which has
 * led to hard to debug issues. It would be best to
 * update it to keep more information in state and
 * render the JSX based on state properties rather
 * than making direct updates to the DOM.
 */

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      header: null,
      windowWidth: window.innerWidth,
      searchOpen: false,
    };

    this.toggleSearch = this.toggleSearch.bind(this);
  }

  componentDidMount() {
    this.props.getWPmenus();

    this.setHeaderOffset();

    window.addEventListener("resize", _.debounce(this.setHeaderOffset), 100);
    window.addEventListener("resize", _.debounce(this.updateWindowWidth), 100);
  }

  setHeaderOffset() {
    const siteWrapper = document.querySelector(".site-wrapper");
    const header = document.querySelector(".main-header__col1-wrapper");
    const main = document.getElementById("main");
    if (window.innerWidth < 1000) {
      main.style.minHeight = "";
    } else {
      main.style.minHeight = `calc(100vh - ${
        header.getBoundingClientRect().height
      }px)`;
    }

    siteWrapper.style.marginTop = `${header.getBoundingClientRect().height}px`;
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.header.menus !== prevProps.header.menus) {
      this.setState({
        ...this.state,
        header: this.props.header,
      });
    }

    if (prevState.header !== this.state.header) {
      this.bodyClass = document.querySelectorAll("body")[0].classList;
      this.mainNavClasses = Array.prototype.slice.call(
        document.querySelectorAll(".main-nav")
      );
      this.navWrapper = Array.prototype.slice.call(
        document.querySelectorAll(".js-nav-wrapper")
      );
      this.navWrapperClasses =
        document.querySelectorAll(".js-nav-wrapper")[0].classList;
      this.subMenu = Array.prototype.slice.call(
        document.querySelectorAll(".js-sub-menu-open")
      );
      this.subMenusMobile = Array.prototype.slice.call(
        document.querySelectorAll(".js-sub-menu-collection-mobile")
      );
      this.navPart2 = Array.prototype.slice.call(
        document.querySelectorAll(".js-main-header-part-2")
      );
      this.wrapper = document.querySelector(".main-header");
      this.menusOpen = false;
      this.mobile = false;
      this.currentlyFocused = null;
      this.prevWidth = null;

      this.init();
      this.setHeaderOffset();
    }

    if (prevState.windowWidth !== this.state.windowWidth) {
      this.init();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowWidth);
  }

  init() {
    if (this.state.windowWidth <= 1024) {
      this.resetMobile();
      this.subMenuOpenMobile();
      this.subMenuCloseMobile();
      this.menuToggleMobile();
      this.mobile = true;
    }

    if (this.state.windowWidth >= 1025) {
      this.resetDesktop();
      this.keyPressNavigation();
      this.subMenuFocus();
      this.mobile = false;
    }
  }

  updateWindowWidth = () => {
    this.setState({ windowWidth: window.innerWidth });
  };

  menuToggleMobile() {
    // initially hide the menu.
    const menuIconToggle = document.querySelector(".js-menu-icon-toggle");
    menuIconToggle.addEventListener("click", this.toggleHandler);
  }

  toggleHandler = (e) => {
    let selected;

    if (e.target.nodeName === "SPAN") {
      selected = e.target.parentNode.classList;
    } else {
      selected = e.target.classList;
    }

    selected.remove("menu-toggle--open");

    if (this.navWrapperClasses.contains("menu-open")) {
      // Close mobile menu.
      this.resetMobile();
      e.currentTarget.setAttribute("aria-expanded", "false");
    } else {
      this.bodyClass.add("no-scroll");
      this.navWrapperClasses.add("menu-open");
      this.navWrapperClasses.add("toggled");
      this.navWrapper[0].setAttribute("aria-hidden", "false");
      e.currentTarget.setAttribute("aria-expanded", true);
    }
  };

  subMenuOpenMobile() {
    const subMenuOpen = document.querySelectorAll(".js-sub-menu-open");
    subMenuOpen.forEach((item) => {
      item.addEventListener("click", this.subMenuOpenHandler);
    });
  }

  subMenuOpenHandler = (e) => {
    const selectedId = e.currentTarget.dataset.subMenuSelect;
    const submenuItem = document.querySelector(
      `.sub-menu-collection-mobile--${selectedId}`
    );

    setTimeout(() => {
      document
        .querySelector(`.sub-menu-collection-mobile--${selectedId} .menu-title`)
        .focus({ preventScroll: true });
    }, 1000);

    this.navWrapper[0].classList.remove("toggled");

    // Show sub menu
    this.navWrapper[0].classList.add("sub-menu-open");

    submenuItem.setAttribute("aria-hidden", "false");

    e.currentTarget.setAttribute("aria-expanded", "true");

    // Hide main menu & nav part 2.
    this.mainNavClasses[0].setAttribute("aria-hidden", "true");
    this.navPart2[0].setAttribute("aria-hidden", "true");
  };

  subMenuClick = (e) => {
    this.subMenuCheck(e.currentTarget, e.target.classList);
  };

  subMenuKeyDown = (e) => {
    if (e.keyCode === 40 || e.keyCode === 13) {
      e.target.classList.add("sub-menu-open");
      e.target.setAttribute("aria-expanded", "true");

      // Toggle sub menu state.
      if (e.keyCode === 13) {
        this.subMenuCheck(e.currentTarget, e.target.classList);
      }
    }
  };

  subMenuFocus() {
    // Desktop only.
    const subMenuOpen = [...document.querySelectorAll(".js-sub-menu-open")];
    const subMenuClose = [...document.querySelectorAll(".js-sub-menu-close")];

    subMenuOpen.forEach((item) => {
      item.addEventListener("click", this.subMenuClick);
      item.addEventListener("keydown", this.subMenuKeyDown);
    });

    subMenuClose.forEach((item) => {
      item.addEventListener("focus", () => {
        const subMenuArr = [...this.subMenu];
        // Close submenus and submenu arias.
        subMenuArr.forEach((item) => {
          item.classList.remove("sub-menu-open");
        });
      });
    });

    subMenuOpen.forEach((item) => {
      item.addEventListener("focus", (e) => {
        [...this.subMenu].forEach((element) => {
          element.setAttribute("aria-expanded", "false");
          element.classList.remove("sub-menu-open");
        });

        // Tab through.
        if (this.menusOpen) {
          e.target.classList.add("sub-menu-open");
        }
      });
      item.addEventListener("blur", () => {
        // Disable menu openings.
        this.menusOpen = false;
      });
    });
  }

  subMenuCheck(target, classList) {
    // Toggle sub menu state.
    if (classList.contains("sub-menu-open")) {
      classList.remove("sub-menu-open");
      target.setAttribute("aria-expanded", "false");
    } else {
      classList.add("sub-menu-open");
      target.setAttribute("aria-expanded", "true");

      // Add flag to ensure each menu has to be 'clicked' into on tab.
      this.menusOpen = true;
    }
  }

  keyPressNavigation() {
    this.topMenu = this.navWrapper[0].querySelectorAll(".main-nav > ul > li");
    this.topMenuArr = [...this.topMenu];

    const toggleIcon = document.querySelector(".js-search-toggle-desktop");

    this.topMenuArr.forEach((item) => {
      item.addEventListener("keydown", this.subMenuOpen);
    });

    const body = document.querySelector("body");
    body.addEventListener("keydown", (e) => {
      if (e.keyCode === 27 && this.wrapper.classList.contains("search-open")) {
        this.searchDesktop();
        toggleIcon.focus();
      }
    });
  }

  subMenuOpen = (e) => {
    const currentMenu = e.target.parentNode.parentNode.parentNode;
    const parentMenuItem = currentMenu.parentNode.previousElementSibling;
    const subMenuNextItem =
      e.target.parentNode.nextElementSibling &&
      e.target.parentNode.nextElementSibling.firstChild;
    const subMenuPrevItem =
      e.target.parentNode.previousElementSibling &&
      e.target.parentNode.previousElementSibling.firstChild;

    // Close.
    if (e.keyCode === 27) {
      if (e.target.classList.contains("sub-menu-open")) {
        e.target.classList.remove("sub-menu-open");
        e.target.setAttribute("aria-expanded", "false");
      } else if (e.target.classList.contains("js-sub-menu-link")) {
        parentMenuItem.setAttribute("aria-expanded", "false");
        parentMenuItem.focus();
      }
    }

    // Main nav.
    this.arrowHorizontal(e);

    // Submenu Vertical.
    this.arrowVertical(
      e,
      currentMenu,
      subMenuNextItem,
      subMenuPrevItem,
      parentMenuItem
    );

    // Navigate right in submenu.
    if (e.keyCode === 39) {
      if (
        currentMenu.nextElementSibling &&
        currentMenu.nextElementSibling !== null
      ) {
        currentMenu.nextElementSibling.querySelectorAll("ul li a")[0].focus();
      } else if (parentMenuItem.parentNode.nextElementSibling) {
        // Move to next menu item (top level).
        parentMenuItem.parentNode.nextElementSibling.children[0].focus();
      } else {
        e.target.focus();
      }
    }

    // Navigate left in submenu.
    if (e.keyCode === 37) {
      if (currentMenu.previousElementSibling) {
        currentMenu.previousElementSibling
          .querySelectorAll("ul li a")[0]
          .focus();
      }
    }
  };

  arrowHorizontal(e) {
    // left 37, up 38, right 39, down 40.
    const index = this.topMenuArr.indexOf(e.target.parentNode);

    if (e.keyCode === 39) {
      if (index + 1 < this.topMenuArr.length) {
        this.topMenuArr[index + 1].children[0].focus();
        this.currentlyFocused = this.topMenuArr[index + 1];
      }
    }
    if (e.keyCode === 37) {
      if (index > 0) {
        this.topMenuArr[index - 1].children[0].focus();
        this.currentlyFocused = this.topMenuArr[index - 1];
      }
    }
  }

  arrowVertical(
    e,
    currentMenu,
    subMenuNextItem,
    subMenuPrevItem,
    parentMenuItem
  ) {
    const menuFromMain = e.target.nextElementSibling;

    // Down
    if (e.keyCode === 40 || e.type === "click") {
      e.preventDefault();

      if (currentMenu.classList.contains("main-nav")) {
        // If it's on the parent menu item link.
        if (menuFromMain !== null) {
          // Focus on to first submenu item if it's been opened from a previous trigger.
          if (
            menuFromMain
              .querySelector("ul li a")
              .classList.contains("sub-menu-open")
          ) {
            menuFromMain.querySelector("ul li a").focus();
          }

          menuFromMain.querySelector("ul li a").classList.add("sub-menu-open");
        }
      }

      if (e.target.parentNode.nextElementSibling) {
        // Check that there's a dom element.
        if (subMenuNextItem instanceof Element) {
          subMenuNextItem.focus();
        }
      } else if (currentMenu.nextElementSibling) {
        // Next submenu list.
        currentMenu.nextElementSibling.querySelector("ul li a").focus();
      } else if (parentMenuItem.parentNode.nextElementSibling) {
        // Last list item of current menu.
        parentMenuItem.parentNode.nextElementSibling.children[0].focus();
      }
    }

    // Up.
    if (e.keyCode === 38) {
      e.preventDefault();

      if (e.target.parentNode.previousElementSibling) {
        if (subMenuPrevItem instanceof Element) {
          subMenuPrevItem.focus();
        }
      } else if (currentMenu.previousElementSibling) {
        // Next submenu list.
        currentMenu.previousElementSibling
          .querySelector("ul li:last-child a")
          .focus();
      } else {
        // If first submenu item go back ot parent.
        parentMenuItem.focus();
      }
    }
  }

  subMenuCloseMobile() {
    const subMenuClose = document.querySelectorAll(".js-sub-menu-close");
    subMenuClose.forEach((item) => {
      item.addEventListener("click", (e) => {
        const selectedId = e.currentTarget.dataset.subMenuSelect;
        const submenuItem = document.querySelector(
          `.sub-menu-btn--${selectedId}`
        );

        // Move focus back to main nav after 1000ms to account for it's css visibility change.
        setTimeout(() => {
          submenuItem.focus();
        }, 2000);

        this.resetMobile(false, false, true);
      });
    });
  }

  toggleSearch(e) {
    e.preventDefault();
    this.setState({ searchOpen: !this.state.searchOpen });
    setTimeout(() => {
      if (this.state.searchOpen) {
        const searchInput = document.querySelector(".js-search-input-desktop");
        searchInput.focus();
      }
    }, 300);
  }

  resetMobile(all = true, mainMenu = true, submenu = true) {
    const toggle = document.querySelector(".js-menu-icon-toggle");
    const desktopSubMenus = Array.prototype.slice.call(
      document.querySelectorAll(".main-nav .sub-menu-collection--desktop")
    );

    // Prepare the mobile menu from intial page load.
    this.subMenusMobile &&
      this.subMenusMobile[0].parentNode.removeAttribute("hidden");

    // Hide Desktop SubMenus.
    desktopSubMenus.forEach((element) => {
      element.setAttribute("aria-hidden", "true");
    });

    // Main Menu reset.
    if (all === true || mainMenu === true) {
      toggle.classList.add("menu-toggle--open");
      this.bodyClass.remove("no-scroll");
      this.navWrapperClasses.remove("menu-open");
      this.navWrapperClasses.remove("toggled");
      this.navWrapper[0].setAttribute("aria-hidden", "true");
    }

    // Sub Menu reset.
    if (all === true || submenu === true) {
      this.navWrapperClasses.remove("sub-menu-open");
      this.mainNavClasses[0].setAttribute("aria-hidden", "false");
      this.navPart2[0].setAttribute("aria-hidden", "false");

      // Close submenus and submenu arias.
      this.subMenu.forEach((item) => {
        // Delay to ensure menu is out of sight.
        setTimeout(() => {
          item.setAttribute("aria-expanded", "false");
        }, 1000);
      });

      this.subMenusMobile.forEach((item) => {
        item.setAttribute("aria-hidden", "true");
      });
    }
  }

  resetDesktop() {
    const toggle = document.querySelector(".js-menu-icon-toggle");
    const mobileSubMenus = document.querySelector(".mobile-sub-menus") || {};
    const desktopSubMenus = [
      ...document.querySelectorAll(".main-nav .sub-menu-collection--desktop"),
    ];
    const subMenusMobileArr = [
      ...(this.subMenusMobile ? this.subMenusMobile : []),
    ];

    mobileSubMenus.hidden = true;

    // Show main menu & nav part 2.
    toggle.classList.remove("menu-toggle--open");

    this.navWrapper[0].setAttribute("aria-hidden", "false");

    this.navWrapperClasses.remove("menu-open");
    this.navWrapperClasses.remove("toggled");

    this.mainNavClasses[0].setAttribute("aria-hidden", "false");
    this.navPart2[0].setAttribute("aria-hidden", "false");

    // Submenus
    this.navWrapper[0].classList.remove("sub-menu-open");

    subMenusMobileArr.forEach((item) => {
      item.setAttribute("aria-hidden", "true");
    });

    // Hide Desktop SubMenus.
    desktopSubMenus.forEach((element) => {
      element.setAttribute("aria-hidden", "false");
    });

    this.setState({ searchOpen: false });
  }

  render() {
    return (
      <header
        className={`main-header ${this.state.searchOpen ? " search-open" : ""}`}
      >
        <div
          className="main-header__search-mobile container"
          aria-hidden="true"
        >
          <form
            className="search-form-wrapper grid u-d-flex u-flex-direction-row u-align-items-center"
            action={window.WEBSITE_ROOT}
            aria-label="Main site search"
          >
            <div className="search-form-wrapper__left cell-2 u-d-flex main-header__search-mobile__back">
              <button
                type="button"
                className="js-remove-search-mobile"
                onClick={this.toggleSearch}
              >
                <span className="assistive-text">Cancel search</span>
                <svg
                  focusable="false"
                  aria-hidden="true"
                  role="img"
                  alt="Cancel search"
                >
                  <use xlinkHref="#cross"></use>
                </svg>
              </button>
            </div>
            <div className="search-form-wrapper__center search-form-wrapper--mobile cell-12">
              <label htmlFor="search-mobile" className="input-label">
                Search
              </label>
              <input
                id="search-mobile"
                className="js-search-input-mobile"
                type="text"
                name="s"
                placeholder="What are you looking for?"
              />
            </div>
            <button
              type="submit"
              className="search-form-wrapper__right u-d-flex u-justify-content-flex-end main-header__search-mobile__submit"
            >
              <span className="assistive-text">Search this website</span>
              <svg aria-hidden="true" role="img" alt="Search this website">
                <use xlinkHref="#search"></use>
              </svg>
            </button>
          </form>
        </div>
        <div className="main-header__relative-container">
          <div className="main-header__col1-wrapper logo">
            <a className="logo" href={window.WEBSITE_ROOT}>
              <span className="assistive-text">Homepage</span>
              <svg aria-hidden="true" role="img" alt="Betterbybike logo">
                <use xlinkHref="#bbb-logo"></use>
              </svg>
            </a>
            <button
              className="menu-search js-menu-search"
              onClick={this.toggleSearch}
              aria-expanded={this.state.searchOpen}
            >
              <span className="assistive-text">Toggle search</span>
              <svg aria-hidden="true" role="img" alt="Search this website">
                <use xlinkHref="#search"></use>
              </svg>
            </button>
            <button
              className="menu-toggle js-menu-icon-toggle"
              aria-label="Toggle Menu"
              aria-expanded="false"
            >
              <span></span>
              <span></span>
            </button>
          </div>
          <div className="main-header__col2 js-nav-wrapper" aria-hidden="false">
            <div className="main-header__col2__part-1">
              <nav
                className="main-nav"
                aria-label="Main site navigation"
                aria-hidden="false"
              >
                <ul className="mobile-links">
                  <li>
                    <a href="/route-planning" className="heading-link u-sr-md">
                      <svg className="heading-link__icon">
                          <use href="#route-planner" />
                      </svg>
                      <span>Route Planner</span>
                    </a>
                  </li>
                  <li>
                    <a href="/cycle-routes" className="heading-link u-sr-md">
                      <svg className="heading-link__icon">
                          <use href="#cycling-route" />
                      </svg>
                      <span>Cycle Routes</span>
                    </a>
                  </li>
                  <li>
                    <a href="/leisure-rides" className="heading-link u-sr-md">
                      <svg className="heading-link__icon">
                          <use href="#leisure-ride" />
                      </svg>
                      <span>Leisure Rides</span>
                    </a>
                  </li>
                  <li>
                    <a href="/cycle-hire" className="heading-link u-sr-md">
                      <svg className="heading-link__icon">
                          <use href="#bike-rentals" />
                      </svg>
                      <span>Bike Shops & Rentals</span>
                    </a>
                  </li>
                  <li>
                    <a href="/public-pumps" className="heading-link u-sr-md">
                      <svg className="heading-link__icon">
                          <use href="#pump-white" />
                      </svg>
                      <span>Public Bike Pumps</span>
                    </a>
                  </li>
                </ul>
                {this.state.header && (
                  <HeaderNav {...this.state.header}></HeaderNav>
                )}
                <ul className="social-nav social-nav--mobile social-nav--v-align">
                  <li className="social-nav__small-item social-nav__social-icon">
                    <a
                      href="https://www.facebook.com/betterbybikeUK"
                      target="_blank"
                      className="js-sub-menu-close"
                    >
                      <span className="assistive-text">
                        Visit Betterbybike on Facebook (opens in a new window)
                      </span>
                      <svg>
                        <use xlinkHref="#facebook"></use>
                      </svg>
                    </a>
                  </li>

                  <li className="social-nav__small-item social-nav__social-icon">
                    <a href="https://twitter.com/betterbybike/" target="_blank">
                      <span className="assistive-text">
                        Visit Betterbybike on Twitter (opens in a new window)
                      </span>
                      <svg>
                        <use xlinkHref="#twitter"></use>
                      </svg>
                    </a>
                  </li>

                  <li className="social-nav__small-item social-nav__social-icon">
                    <a
                      href="https://www.instagram.com/betterbybikeuk/"
                      target="_blank"
                    >
                      <span className="assistive-text">
                        Visit Betterbybike on Instagram (opens in a new window)
                      </span>
                      <svg>
                        <use xlinkHref="#instagram"></use>
                      </svg>
                    </a>
                  </li>
                </ul>
              </nav>
              {this.state.header && (
                <HeaderMobileNav {...this.state.header}></HeaderMobileNav>
              )}
            </div>
            <div
              className="main-header__col2__part-2 js-main-header-part-2"
              aria-hidden="false"
            >
              <ul className="social-nav social-nav--v-align">
                <li className="social-nav__small-item social-nav__social-icon">
                  <a
                    href="https://www.facebook.com/betterbybikeUK/"
                    target="_blank"
                    className="js-sub-menu-close"
                  >
                    <span className="assistive-text">
                      Go to our Facebook page (opens in a new window)
                    </span>
                    <svg aria-hidden="true">
                      <use xlinkHref="#facebook"></use>
                    </svg>
                  </a>
                </li>
                <li className="social-nav__small-item social-nav__social-icon">
                  <a href="https://twitter.com/betterbybike/" target="_blank">
                    <span className="assistive-text">
                      Go to our Twitter page (opens in a new window)
                    </span>
                    <svg aria-hidden="true">
                      <use xlinkHref="#twitter"></use>
                    </svg>
                  </a>
                </li>
                <li className="social-nav__small-item social-nav__social-icon">
                  <a
                    href="https://www.instagram.com/betterbybikeuk/"
                    target="_blank"
                  >
                    <span className="assistive-text">
                      Go to our Instagram page (opens in a new window)
                    </span>
                    <svg aria-hidden="true" className="instagram">
                      <use xlinkHref="#instagram"></use>
                    </svg>
                  </a>
                </li>
                <li className="social-nav__small-item social-nav__small-item--highlight">
                  <button
                    className="js-search-toggle js-search-toggle-desktop u-d-none u-d-block-md"
                    onClick={this.toggleSearch}
                    type="button"
                    aria-haspopup="true"
                    aria-expanded={this.state.searchOpen}
                  >
                    <span className="assistive-text">
                      Main site search toggle
                    </span>
                    <div className="icon-holder">
                      <div className="menu-toggle menu-toggle--search"></div>
                      <svg
                        aria-hidden="true"
                        role="img"
                        alt="Search this website"
                      >
                        <use xlinkHref="#search" />
                      </svg>
                    </div>
                  </button>
                  <div
                    className="main-header__search-desktop"
                    aria-hidden={!this.state.searchOpen}
                  >
                    <form
                      className="main-header__search-desktop__form"
                      action={window.WEBSITE_ROOT}
                      aria-label="Main site search"
                    >
                      <label htmlFor="search-desktop" className="input-label">
                        Search
                      </label>
                      <input
                        id="search-desktop"
                        className="js-search-input-desktop"
                        type="text"
                        name="s"
                        placeholder="What are you looking for?"
                      />
                      <button
                        className="search-enter"
                        type="submit"
                        aria-haspopup="true"
                      >
                        <span className="assistive-text">Submit Search</span>
                        <svg
                          aria-hidden="true"
                          role="img"
                          alt="Search this website"
                        >
                          <use xlinkHref="#search"></use>
                        </svg>
                      </button>
                    </form>
                  </div>
                </li>
              </ul>
              <Link
                className="main-header__plan nav-btn"
                to={`${window.ROOT}/route-planning`}
              >
                Plan a Route{" "}
                <svg aria-hidden="true">
                  <use xlinkHref="#arrow-right" />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js